export default __webpack_public_path__ + "static/media/logoTimescope.7a4494c2.svg";